<script lang="ts">
	import type Category from "../../../class/StoreItem/Category";
	//
	import {
		AdaptiveTextInput,
		DefaultButton,
		DefaultSwitch,
		InlineButton,
	} from "@hitit/new_ui";
	import CollectionPopup from "../CollectionPopup.svelte";
	//Utils
	import { createEventDispatcher } from "svelte";
	import { clickOutside } from "@hitit/utils";
	import { getKeyInTranslation } from "../../../utils";
	import { t } from "@hitit/hub/src/stores";
	import { TranslationDTO } from "../../../class/TranslationDTO";

	export let category: Category;
	export let clickOutsideCallBack = () => {};

	let inputValue = getKeyInTranslation(
		category.getTranslations(),
		"name",
		"ko"
	);

	const dispatch = createEventDispatcher();
	const deleteEvent = () => dispatch("DELETE_CATEGORY", category);

	const parsingChecked = (e: Event) => {
		const target = e.target as HTMLInputElement;
		return target.checked;
	};

	const enableHandler = (e: Event) => {
		const checked = parsingChecked(e);
		const dto = category.getCategoryDTO();
		dto.enabled = checked;
		dispatch("UPDATE_CATEGORY", dto);
	};

	const rewardableHandler = (e: Event) => {
		const checked = parsingChecked(e);
		const dto = category.getCategoryDTO();
		dto.rewardable = checked;
		dispatch("UPDATE_CATEGORY", dto);
	};

	const taxableHandler = (e: Event) => {
		const checked = parsingChecked(e);
		const dto = category.getCategoryDTO();
		dto.taxable = checked;
		dispatch("UPDATE_CATEGORY", dto);
	};

	const nameButtonHandler = () => {
		const defaultTranslation =
			category
				.getTranslations()
				.find((v) => v.defaultLang && v.lang === "ko") ||
			new TranslationDTO(inputValue);
		const dto = category.getCategoryDTO();
		const newTranslation = Object.assign({}, defaultTranslation);

		newTranslation.name = inputValue || "";

		dto.translationDTOs = [
			...category
				.getTranslations()
				.filter((v) => !(v.defaultLang && v.lang === "ko")),
			newTranslation,
		];

		dispatch("UPDATE_CATEGORY", dto);
	};

</script>

<div class="container" use:clickOutside={clickOutsideCallBack}>
	<CollectionPopup>
		<div class="inner">
			<div class="f-col">
				<label for="">{$t('global.product.category.edit_category_name')}</label>
				<div class="input-button">
					<div class="input">
						<AdaptiveTextInput
							bind:value={inputValue}
							placeholder={$t('global.product.category.category_name')} />
					</div>
					<div class="button">
						<DefaultButton fitmode nonePadding on:click={nameButtonHandler}>
							<span class="button-inner">{$t('global.save')}</span>
						</DefaultButton>
					</div>
				</div>
			</div>
			<div class="f-col">
				<div class="f-between">
					<label for="">{$t('global.product.category.enabled')}</label>
					<DefaultSwitch checked={category.enabled} on:change={enableHandler} />
				</div>
			</div>
			<div class="f-col">
				<div class="f-between">
					<label for="">{$t('global.product.category.rewardable')}</label>
					<DefaultSwitch
						checked={category.rewardable}
						on:change={rewardableHandler} />
				</div>
			</div>
			<div class="f-col">
				<div class="f-between">
					<label for="">{$t('global.product.category.taxable')}</label>
					<DefaultSwitch
						checked={category.taxable}
						on:change={taxableHandler} />
				</div>
			</div>
			<div class="seperate" />
			<div class="f-between">
				<label for="">{$t('global.product.category.delete_category')}</label>
				<InlineButton on:click={deleteEvent}>
					<img id="delete" src="/icons/deleteIcon.png" alt="" />
				</InlineButton>
			</div>
		</div>
	</CollectionPopup>
</div>

<style lang="scss">
	@import "../../../../variables.scss";

	.container {
		position: absolute;
		left: 0;
		top: 46px;
		z-index: 9;

		&:hover {
			cursor: default;
		}

		#delete {
			width: 26px;
			height: 26.2px;
		}

		.seperate {
			width: 100%;
			height: 1px;
			background-color: #bcbfc3;
		}

		.inner {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}

		.button-inner {
			color: white;
			font-weight: 500;
			font-size: 1rem;
			line-height: 26px;
		}

		.f-between {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		.input-button {
			display: flex;
			gap: 10px;
			height: 32px;

			.input {
				font-size: 1rem;
				color: #46474b;
				flex-grow: 1;
			}

			.button {
				width: 60px;
			}
		}

		.f-col {
			display: flex;
			flex-direction: column;
			gap: 10px;
		}

		label {
			color: white;
		}
	}

	@include DesktopSize {
		.container {
			.inner {
				gap: 24px;
			}

			.button-inner {
				font-size: 1.25rem;
			}

			.input-button {
				height: 40px;
			}

			label {
				font-size: 1.25rem;
			}
		}
	}

</style>
